import { CenterOlPaymentTypeEnum } from '../../lib/types/enums/center-ol-payment/center-ol-payment-type.enum'
import { CurrencyEnum } from '../../lib/types/enums/common/currency.enum'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type SuggestedValues = {
  label: string
  value: number
}

type CenterOlPaymentSuggestionsInput = {
  olId: number
  centerId?: number
  type?: CenterOlPaymentTypeEnum
}

type CenterOlPaymentSuggestionsResponse = {
  centers: SuggestedValues[] // centers to pick from that are related to the OL
  centerId?: number // selected from the centers related to the OL

  countryId?: number // country related to the selected center
  periods?: SuggestedValues[] // periods to pick from that are related to the selected center

  label?: string
  lecBankAccountId?: number // only when an ol is selected, the lec bank account is suggested based on the currency of the ol
  currency?: CurrencyEnum
  amount?: number
}

export function getCenterOlPaymentSuggestions(input: CenterOlPaymentSuggestionsInput) {
  return restApiClient
    .url(
      encodeNestedObject<CenterOlPaymentSuggestionsInput>(
        API.centerOlPayments.getSuggestions.url,
        input
      )
    )
    .get<CenterOlPaymentSuggestionsResponse>()
}
